import React, { useState } from 'react';
import ProductCard from './ProductCard';

function Products({ products, weeklyBasket, basketDate }) {
  // State for weekly basket quantities
  const [basketQuantities, setBasketQuantities] = useState({});

  // Initialize quantities when weeklyBasket changes
  React.useEffect(() => {
    if (weeklyBasket && weeklyBasket.length > 0) {
      const initialQuantities = {};
      weeklyBasket.forEach(product => {
        initialQuantities[product.id] = product.minAmount || 0;
      });
      setBasketQuantities(initialQuantities);
    }
  }, [weeklyBasket]);

  // Generate basket title from the date
  const generateBasketTitle = (dateString) => {
    if (!dateString) return "Cesta Semanal";
    
    try {
      var basketTitle;
      var createdAt = new Date(parseInt(dateString.split(' ')[1]) * 1000);
      createdAt.setDate(createdAt.getDate() + 2);
      createdAt.setDate(createdAt.getDate() - createdAt.getDay() + 2);

      var basketLimit = new Date(createdAt.getTime() + (1000*60*60*24*3));
      var monthLimit = basketLimit.toLocaleString("pt-pt", { month: "long" });
      monthLimit = monthLimit.charAt(0).toUpperCase() + monthLimit.slice(1);

      basketTitle = "Semana de " + createdAt.getDate() + " a " + basketLimit.getDate() + " de " + monthLimit;
      return basketTitle;
    } catch (error) {
      console.error('Error generating basket title:', error);
      return "Cesta Semanal";
    }
  };

  // Handle quantity changes for weekly basket items
  const handleBasketQuantityChange = (productId, newQuantity) => {
    const product = weeklyBasket.find(p => p.id === productId);
    if (!product) return;

    const minAmount = product.minAmount || 0;
    const step = product.atfStep || 1;
    
    // Ensure quantity doesn't go below minimum
    if (newQuantity >= minAmount) {
      // Round to nearest step
      const roundedQuantity = Math.round(newQuantity / step) * step;
      setBasketQuantities(prev => ({
        ...prev,
        [productId]: roundedQuantity
      }));
    }
  };

  const incrementBasketQuantity = (productId) => {
    const product = weeklyBasket.find(p => p.id === productId);
    if (!product) return;

    const currentQuantity = basketQuantities[productId] || 0;
    const step = product.atfStep || 1;
    handleBasketQuantityChange(productId, currentQuantity + step);
  };

  const decrementBasketQuantity = (productId) => {
    const product = weeklyBasket.find(p => p.id === productId);
    if (!product) return;

    const currentQuantity = basketQuantities[productId] || 0;
    const step = product.atfStep || 1;
    const minAmount = product.minAmount || 0;
    
    if (currentQuantity - step >= minAmount) {
      handleBasketQuantityChange(productId, currentQuantity - step);
    }
  };

  const removeBasketItem = (productId) => {
    // Remove the item from weeklyBasket
    const updatedBasket = weeklyBasket.filter(product => product.id !== productId);
    
    // Update the parent component's state
    // Since we can't directly modify the parent state, we'll need to pass this up
    // For now, we'll use a custom event or you can implement a callback prop
    
    // Remove from quantities state
    setBasketQuantities(prev => {
      const newQuantities = { ...prev };
      delete newQuantities[productId];
      return newQuantities;
    });
    
    // Dispatch custom event to notify parent component
    const event = new CustomEvent('basketItemRemoved', { 
      detail: { productId, updatedBasket } 
    });
    window.dispatchEvent(event);
  };

  const basketTitle = generateBasketTitle(basketDate);

  return (
    <div className="products-container">
      {/* Main Products Area */}
      <div className="main-products-area">
        <div data-block="Adaptive.Gallery" className="OSBlockWidget" id="$b2">
          <div 
            className="grid-gallery" 
            id="b2-Content" 
            style={{
              '--grid-desktop': '4',
              '--grid-tablet': '3', 
              '--grid-phone': '1',
              '--grid-gap': 'var(--space-base)',
              '--grid-list-desktop': '5',
              '--grid-list-tablet': '4',
              '--grid-list-phone': '2'
            }}
          >
            <ul data-list="" className="list list-group OSFillParent" style={{ position: 'relative' }}>
              {products.map((product) => (
                <li key={product.id} data-advancedhtml="">
                  <ProductCard product={product} />
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Weekly Basket Sidebar */}
      {weeklyBasket && weeklyBasket.length > 0 && (
        <div className="weekly-basket-section">
          <h3>{basketTitle}</h3>
          <div className="weekly-basket-products">
            {weeklyBasket.map((product) => (
              <div key={product.id} className="weekly-basket-item">
                <div className="product-thumbnail">
                  {product.thumbnail && (
                    <img src={product.thumbnail} alt={product.name} />
                  )}
                </div>
                <div className="product-info">
                  <div className="product-name">{product.name}</div>
                  <div className="product-price">
                    €{product.regularPrice} / {product.atfPriceLbl}
                  </div>
                  <div className="product-quantity">
                    <button 
                      className="quantity-btn" 
                      onClick={() => decrementBasketQuantity(product.id)}
                    >
                      -
                    </button>
                    <span className="quantity">{basketQuantities[product.id] || product.minAmount}</span>
                    <button 
                      className="quantity-btn" 
                      onClick={() => incrementBasketQuantity(product.id)}
                    >
                      +
                    </button>
                  </div>
                </div>
                <button className="remove-btn" onClick={() => removeBasketItem(product.id)}>×</button>
              </div>
            ))}
          </div>
          
          {/* Basket Summary */}
          <div className="basket-summary">
            <div className="summary-item">
              <span>Azeite</span>
              <span>€0</span>
            </div>
            <div className="summary-total">
              <span>Total</span>
              <span>€{weeklyBasket.reduce((sum, product) => {
                const quantity = basketQuantities[product.id] || product.minAmount;
                return sum + (product.regularPrice * quantity);
              }, 0).toFixed(1)}</span>
            </div>
            <div className="summary-delivery">
              <span>Entrega</span>
              <span>Oferta</span>
            </div>
          </div>
          
          {/* Action Buttons */}
          <div className="basket-actions">
            <button className="reset-btn">Repor Cabaz</button>
            <button className="checkout-btn">Entrar</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Products;

